<template>
    <div class="wrapper">
        <header v-if="!isPhone">
            <TheHeaderBar :title="title"/>
        </header>
        <div class="content">
            <div class="address-details-box">
                <van-address-edit
                        :area-list="areaList"
                        show-postal
                        show-delete
                        show-set-default
                        :show-delete="addressId === 0 ? false : true"
                        :address-info="addressDetailsInfo"
                        show-search-result
                        @change-area="handleChangeArea"
                        @save="handleSave"
                        @delete="handleDelete"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import TheHeaderBar from "../../components/base/TheHeaderBar";
    import {areaList} from '../../data/area';
    import {
        getAddressDetailsService,
        updateAddressService,
        addAddressService, deleteAddressService,
    } from '../../service/userService';
    import {Dialog, Toast} from 'vant';
    import {mapState} from "vuex";
    import {getUrlParamsTools, phoneInteractiveTools} from "../../util/tools";
    import phoneInteractiveData from "../../data/phoneInteractiveData";
	import {wecharShare} from "../../util/weChat.js";

    export default {
        name: "SetAddress",
        data(){
            return{
                addressId:0,//地址编号
                title:'新增我的收货地址',//标题
                areaList:{},// 省市区信息
                addressDetailsInfo:{},//收货地址详细信息
                sendAddressDetailsInfo:{},//发送给后台的收货地址信息
                isPhone: false,
                phoneState:"IOS",
            }
        },
        mounted() {
            //获取省市区信息
            this.areaList = areaList;

            //addressId值为 0 时为新增 其他值为编辑
            this.addressId = parseInt(this.$route.params.addressId);
            if(this.addressId !== 0){
                this.title = '编辑我的收货地址';
                //获取我的收货地址
                this.getAddressDetails();
            }

            const state = getUrlParamsTools('isPhone') || sessionStorage.getItem('inP');
            if(state){
                this.isPhone = true;
                this.phoneState = getUrlParamsTools('phoneState') || sessionStorage.getItem('phoneS');
                phoneInteractiveTools(phoneInteractiveData.interactiveTitle,this.phoneState, this.title);
            }
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{

            //获取我的收货地址
            getAddressDetails(){
                getAddressDetailsService(this.addressId).then(res => {
                    if(res.status === 1){
                        this.addressDetailsInfo = res.datas;
                        this.sendAddressDetailsInfo.province = res.datas.province;
                        this.sendAddressDetailsInfo.city = res.datas.city;
                        this.sendAddressDetailsInfo.district = res.datas.areaCode;
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {});
            },

            //保存
            handleSave(content){
                if(this.addressId === 0){
                    this.handleAddAddress(content);
                }else{
                    this.handleUpdateAddress(content);
                }
            },

            //改变地址
            handleChangeArea(values){
                this.sendAddressDetailsInfo.province = values[0].code;
                this.sendAddressDetailsInfo.city = values[1].code;
                this.sendAddressDetailsInfo.district = values[2].code;
            },

            //新增我的收货地址
            handleAddAddress(content){
                //拼接发送给后台的数据
                this.formatSendObj(content);
                addAddressService(this.userId,this.sendAddressDetailsInfo).then(res => {
                    if(res.status === 1){
                        Dialog.alert({
                            message: '新增成功'
                        }).then(() => {
                            this.$router.go(-1);
                        })
                    }else {
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {});
            },

            //修改我的收货地址
            handleUpdateAddress(content){
                //拼接发送给后台的数据
                this.formatSendObj(content);
                updateAddressService(this.userId,this.sendAddressDetailsInfo).then(res => {
                    if(res.status === 1){
                        Dialog.alert({
                            message: '修改成功'
                        }).then(() => {
                            this.$router.go(-1);
                        })
                    }else {
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {});
            },

            //删除收货地址
            handleDelete(){
                deleteAddressService(this.addressId).then(res => {
                    if(res.status === 1){
                        Dialog.alert({
                            message: '删除成功'
                        }).then(() => {
                            this.$router.go(-1);
                        })
                    }else {
                        Toast(res.msg)
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            //格式化发送给后台的收货地址信息
            formatSendObj(obj){
                if(this.addressId !== 0){
                    this.sendAddressDetailsInfo.id = this.addressId ;
                }
                this.sendAddressDetailsInfo.name = obj.name;
                this.sendAddressDetailsInfo.tel = obj.tel;
                this.sendAddressDetailsInfo.address = obj.addressDetail;
                this.sendAddressDetailsInfo.code = obj.postalCode;
                this.sendAddressDetailsInfo.is_default = obj.isDefault ? 1 : 0;
            }
        },
        computed:{
            ...mapState({
                userId: state => state.userInfo.userId,
            })
        },
        components: {
            TheHeaderBar,
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        header{
            padding-bottom: 46px;
        }
        .content{
            /*padding-top: 46px;*/
        }
    }
</style>